import { Component, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-confirm-popup',
  templateUrl: './confirm-popup.component.html',
  styleUrls: ['./confirm-popup.component.scss']
})
export class ConfirmPopupComponent implements OnInit {

  @Input('showModal')
  showModal = false
  @Input('cancelText')
  cancelText = 'Cancel'
  @Input('confirmText')
  confirmText = 'Confirm'
  @Input('header')
  header = 'Confirm'
  @Input('description')
  description = 'Please Confirm'

  @Output('onCancel')
  onCancel: any = () => {}

  @Output('onConfirm')
  onConfirm: any = () => {}

  constructor() { }

  ngOnInit(): void {
  }

}
